import { Link } from "gatsby-link";
import React from "react";
import logo from "assets/images/header/logo.svg";
import instagram from "assets/images/social-media/instagram.svg";
import linkedin from "assets/images/social-media/linkedin.svg";
import facebook from "assets/images/social-media/facebook.svg";
import twitter from "assets/images/social-media/twitter-x.svg";
import telegram from "assets/images/social-media/telegram.svg";
import youtube from "assets/images/social-media/youtube.svg";
import pinterest from "assets/images/social-media/pinterest.svg";
import koo from "assets/images/social-media/koo.svg";
import { data } from "./config";

function Footer() {
  return (
    <div className="bg-black px-4 lg:px-10 py-8 lg:pt-14 lg:pb-6">
      <div className="lg:flex gap-7 xl:gap-16 justify-between 2xl:max-w-7xl 2xl:mx-auto">
        <div className="pb-11 lg:pb-0">
          <Link to="/" className="flex gap-3 items-center justify-start pb-4">
            <img src={logo} alt="logo" />
            <p className="text-lg lg:text-2xl text-primary xs:font-cairo flex flex-col">
              <span>LegalSections</span>
              <span className="text-sm lg:text-base text-white xs:font-cairo self-end">
                Law That Leads
              </span>
            </p>
          </Link>
          <p className="text-sm text-white text-justify xs:font-cairo max-w-xs">
            Ready to solve your legal matters with confidence? Contact our
            expert legal consultants today and get the guidance you deserve.
            Don't delay, take the first step towards a brighter legal future.
          </p>
        </div>
        <div className="pb-8 lg:pb-0">
          <p className="text-base text-primary xs:font-cairo font-medium md:text-center lg:text-left">
            Explore
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 md:justify-items-center lg:flex gap-x-2 lg:gap-x-9 gap-y-5 pt-4">
            {data.map(({ items }, i) => {
              return (
                <div className="flex flex-col gap-2" key={i}>
                  {items.map((item) => {
                    return (
                      <Link
                        to={item.link}
                        key={item.id}
                        className="text-sm text-greyMid hover:text-primary xs:font-cairo transition-colors duration-300"
                      >
                        {item.text}
                      </Link>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <p className="text-base text-primary text-center lg:text-left xs:font-cairo font-medium pb-5">
            Follow us on
          </p>
          <div className="flex items-center justify-center gap-4">
            <a href="https://www.instagram.com/legalsection/" target="_blank">
              <img src={instagram} alt="instagram" />
            </a>
            <a href="https://www.facebook.com/LegalSections" target="_blank">
              <img src={facebook} alt="facebook" />
            </a>
            <a
              href="https://linkedin.com/company/legalsections"
              target="_blank"
            >
              <img src={linkedin} alt="linkedin" />
            </a>
            <a href="https://twitter.com/LegalSections" target="_blank">
              <img src={twitter} alt="twitter" />
            </a>
            <a
              href="https://www.youtube.com/@legalsections6395"
              target="_blank"
            >
              <img src={youtube} alt="youtube" />
            </a>
            <a href="https://t.me/legalsections" target="_blank">
              <img src={telegram} alt="telegram" />
            </a>
            <a
              href="https://www.kooapp.com/profile/legalsections"
              target="_blank"
            >
              <img src={koo} alt="koo" />
            </a>
          </div>
        </div>
      </div>
      <p className="text-sm text-white text-center xs:font-cairo pt-8">
        &copy; {new Date().getFullYear()} LegalSections. All Rights Reserved.
      </p>
    </div>
  );
}
export default Footer;
